import React, { Component } from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import AOS from "aos"
import 'aos/dist/aos.css';
import NewsStrip from "../../components/news-strip"

class NewsPage extends Component {

  componentDidMount(){
    AOS.init();
    window.addEventListener('load', AOS.refresh);
    // @NOTE: Hack to force AOS to work :(
    window.setTimeout(AOS.refresh, 1000);
  }

  componentDidUpdate() {
    AOS.refresh();
  }

  render() {
    return (
      <Layout>
        <SEO title="Tetley's Coaches are advertising on 'Made in Leeds'" description="Tetley's Coaches have an advertising campaign running on local TV channel 'Made in Leeds' through June and July (Sky channel 117)." />
        <div className="block-services inner-body-bg">
          <div className="body gutter page-content-parent page-article" style={{ background: 'white' }}>
            <div>
              <h1 className="page-content-heading">Tetley's Coaches are advertising on 'Made in Leeds'</h1>
              <p className="news-article-date">June 2016</p>
            </div>

            <div className="news-article-body">
              <p>Tetley's Coaches have an advertising campaign running on local TV channel 'Made in Leeds' through June and July (Sky channel 117).</p>
              <iframe title="Tetley's Made in Leeds advert" width="100%" height="315" src="https://www.youtube.com/embed/ofrhpwYSJKc" frameBorder="0" allowFullScreen={true}></iframe>
            </div>
          </div>
        </div>

        <NewsStrip />

      </Layout>
    );
  }
}

export default NewsPage
